
function NoneValue() {
    return (
        <>-</>
    );
}

export default NoneValue;